<!-- eslint-disable vue/no-v-html -->
<template>
    <Teleport to="body">
        <div
            v-if="visible"
            class="warning-box"
            data-nosnippet
        >
            <div class="warning-content relative">
                <div class="warning-text">
                    <div class="font-promedium text-2xl">
                        {{ $t("welcomeBanner.title") }}
                    </div>
                    <p>{{ $t("welcomeBanner.text_1") }}</p>
                    <p>
                        {{ $t("welcomeBanner.text_2")
                        }}<NuxtLink
                            to="mailto:uap@ipr.praha.eu"
                            class="underline underline-offset-[3px] hover:no-underline"
                        >
                            uap@ipr.praha.eu</NuxtLink
                        >.
                    </p>
                </div>
                <button
                    class="main-button"
                    @click="handleBtnClick"
                >
                    {{ $t("welcomeBanner.button") }}
                </button>
                <div class="no-show-cookies">
                    <!-- <div
                        class="no-show-control"
                        :class="{ active: noShowActive }"
                    /> -->
                    <input
                        v-model="noShowActive"
                        type="checkbox"
                    />
                    <span @click="noShowActive = !noShowActive">{{
                        $t("welcomeBanner.cookies")
                    }}</span>
                </div>
                <button
                    class="absolute right-0 top-0 cursor-pointer bg-white p-3"
                    @click="visible = false"
                >
                    <Icon name="custom:close" />
                </button>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue"

const store = useMainStore()

const COOKIE_NAME = "portal-uap_warning_banner"
const END_DATE = "2025-04-30T00:00:00Z"

const visible = ref(false)
const noShowActive = ref(false)

onMounted(() => {
    const dateNow = new Date().getTime()
    const dateEnd = new Date(END_DATE).getTime()
    const isExpired = dateNow > dateEnd
    if (isExpired) {
        visible.value = false
        return
    }
    const cookie = getCookie(COOKIE_NAME)
    if (cookie === "true") {
        visible.value = false
        noShowActive.value = true
    } else {
        visible.value = true
    }
})

function getCookie(name: string) {
    const cookie: { [k: string]: string } = {}
    document.cookie.split(";").forEach(function (el) {
        const [k, v] = el.split("=")
        if (k && v) {
            cookie[k.trim()] = v
        }
    })
    return cookie[name]
}

function handleBtnClick() {
    if (store.cookiesPermissions.functional) {
        document.cookie = `${COOKIE_NAME}=${noShowActive.value}; max-age=2592000`
    }
    visible.value = false
}

watch(
    () => store.cookiesPermissions.functional,
    newValue => {
        if (newValue) {
            document.cookie = `${COOKIE_NAME}=${noShowActive.value}; max-age=2592000`
        }
    }
)
</script>

<style lang="scss" scoped>
.warning-box {
    @apply fixed left-0 top-0 z-[999] h-full w-full;
    @apply flex items-center justify-center bg-white/20 backdrop-blur-sm;
    .warning-content {
        @apply flex max-w-[84%] flex-col gap-6 border border-black-text bg-white p-6 text-center md:max-w-2xl;
        .warning-text {
            @apply flex flex-col gap-2;
        }
        img {
            @apply mx-auto my-3;
        }
        .main-button {
            @apply mx-auto w-fit border border-black-text bg-black-text px-4 py-2 text-white hover:bg-white hover:text-black-text;
        }
        .no-show-cookies {
            @apply flex cursor-pointer items-center justify-center gap-2;
            .no-show-control {
                @apply relative -top-px h-3 w-3;
                @apply flex items-center justify-center rounded-full border border-black;
                &.active {
                    @apply before:h-1.5 before:w-1.5 before:rounded-full before:bg-black before:content-[''];
                }
            }
        }
    }
}
</style>
